export const SNAKE_CASE_REGEX = /^[a-z0-9]+(_[a-z0-9]+)*$/;

export const PASSWORD_REGEX =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

export const URL_REGEX =
  /^(?!.*\.\.)(?!$)(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*(\?.*)?(?<!\.)$/;

export const SPACE_ID_REGEX = /.*chat\/(dm|space)?\/?/;

export const GOOGLE_CHAT_SPACE_NAME_REGEX = /^spaces\/[A-Za-z0-9-_]+$/;

export const GOOGLE_CHAT_SPACE_URL_REGEX = /((spaces?|room)\/[A-Za-z0-9-_]+)/;

export const GOOGLE_CHAT_APP_SPACE_PATH_REGEX =
  /^\/(?:u\/\d+\/)?app\/chat\/([A-Za-z0-9_-]+)(?:\/|$)/;

export const GOOGLE_DOC_REGEX =
  /https?:\/\/(docs|drive)\.google\.com\/document\/d\/[\w-]+(\/edit)?/;

export const EXTRACT_YOUTUBE_VIDEO_ID_REGEX =
  /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/))([\w-]{11})/;
export const TASK_REGEX = /^\"|\"$/g;

export const DOMAIN_NAME_EXTRACTOR_FROM_EMAIL = /@(.+)$/;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MONGODB_OBJECT_ID_REGEX = /^[a-fA-F0-9]{24}$/;
